import AdvoxPopupQuery from 'Query/AdvoxPopup.query';
import { setAdvoxPopups } from 'Store/AdvoxPopup/AdvoxPopup.action';
import { showNotification } from 'Store/Notification/Notification.action';
import { prepareQuery } from 'Util/Query';
import { executePost, getErrorMessage } from 'Util/Request';

/** @namespace Pwa/Store/AdvoxPopup/Dispatcher */
export class AdvoxPopupDispatcher {
    getAdvoxPopups(dispatch) {
        return executePost(prepareQuery(AdvoxPopupQuery.getPopupQuery(dispatch), true)).then(
            /** @namespace Pwa/Store/AdvoxPopup/Dispatcher/AdvoxPopupDispatcher/getAdvoxPopups/executePost/then */
            (response) => {
                dispatch(setAdvoxPopups(response?.popups));
            },
            /** @namespace Pwa/Store/AdvoxPopup/Dispatcher/AdvoxPopupDispatcher/getAdvoxPopups/executePost/then/dispatch/catch */
            (error) => dispatch(showNotification('error', getErrorMessage(error)))
        );
    }
}

export default new AdvoxPopupDispatcher();
